module.exports = __webpack_public_path__ + "static/media/video-page-bg.48f055df.svg";